var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_FRAGMENT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const variantWithProductFragment_1 = require("./variantWithProductFragment");
exports.ORDER_FRAGMENT = (0, graphql_tag_1.default) `
  fragment OrderFragment on Order {
    id
    name
    orderNumber
    currencyCode
    financialStatus
    fulfillmentStatus
    statusUrl
    customerUrl
    originalTotalPrice {
      amount
      currencyCode
    }
    subtotalPriceV2 {
      amount
      currencyCode
    }
    successfulFulfillments {
      fulfillmentLineItems(first: 50) {
        edges {
          node {
            lineItem {
              title
              quantity
            }
          }
        }
      }
    }
    totalShippingPriceV2 {
      amount
      currencyCode
    }
    totalTaxV2 {
      amount
      currencyCode
    }
    totalPriceV2 {
      amount
      currencyCode
    }
    totalRefundedV2 {
      amount
      currencyCode
    }
    processedAt
    canceledAt
    shippingAddress {
      address1
      address2
      firstName
      lastName
      city
      province
      zip
      country
    }
    lineItems(first: 100) {
      edges {
        cursor
        node {
          title
          variant {
            ...VariantWithProductFragment
          }
          quantity
          customAttributes {
            key
            value
          }
          discountAllocations {
            allocatedAmount {
              amount
              currencyCode
            }
          }
          currentQuantity
          discountedTotalPrice {
            amount
            currencyCode
          }
          originalTotalPrice {
            amount
            currencyCode
          }
        }
      }
    }
  }
  ${variantWithProductFragment_1.VARIANT_WITH_PRODUCT_FRAGMENT}
`;
//# sourceMappingURL=orderFragment.js.map